export const WebSocketStatus = {
  CONNECTED: 'CONNECTED',
  CONNECTING: 'CONNECTING',
  RECONNECTING: 'RECONNECTING',
  CLOSED: 'CLOSED',
} as const;
export type WebSocketStatus = (typeof WebSocketStatus)[keyof typeof WebSocketStatus];
